<template>
  <div class="app-evn-settings-wrapper">
    <div class="evn-header">
    <slot name="evnHeader"><h2>Einzelverbindungsnachweise</h2></slot>
    </div>
      <Current v-if="showCurrent">
        <template v-for="slot in possibleChildSlotsFor('Current')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </Current>
      <Change v-if="showChange">
        <template v-for="slot in possibleChildSlotsFor('Change')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </Change>
      <Success v-if="showSuccess">
        <template v-for="slot in possibleChildSlotsFor('Success')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </Success>
  </div>
</template>

<script>
import Success, { stepName as successStepName } from './Success.vue'
import Change, { stepName as changeStepName } from './Change.vue'
import Current, { stepName as currentStepName } from './Current.vue'
import { mapGetters } from 'vuex'
import transaction from '@/mixins/transaction'
import slotProxy from '@/mixins/slotProxy'

export default {
  name: 'EvnWrapper',
  mixins: [
    transaction('changeEvnSettings'),
    slotProxy()
  ],
  components: { Current, Change, Success },
  computed: {
    ...mapGetters('evn', [
      'getStep'
    ]),
    showCurrent () {
      return this.getStep === currentStepName
    },
    showChange () {
      return this.getStep === changeStepName
    },
    showSuccess () {
      return this.getStep === successStepName
    }
  },
  methods: {}
}
</script>
